import { cn } from '@cobliteam/ui/utils';
import type React from 'react';

interface BlankslateProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode;
}

const Blankslate = ({ children, className, ...props }: BlankslateProps) => {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-4', className)} {...props}>
      {children}
    </div>
  );
};

export default Blankslate;
